import React from "react";
import { AppBar, Toolbar, Typography, withStyles, Theme, createStyles, WithStyles, Hidden, Link } from "@material-ui/core";
import { Person, Phone, Email } from "@material-ui/icons";
import { ClientAppConfig } from "../util/AppUtil";

const styles = (theme: Theme) => createStyles({
    appBar: {
        position: 'static',
        alignItems: 'center',
    },
    subBar: {
        position: 'static',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            position: 'static',
            alignItems: 'center',
        }
    },
    subToolbar: {
        minHeight: '45px'
    },
    logo: {
        maxHeight: '50px',
        marginRight: theme.spacing(2),
    }
});

interface HeaderProps extends WithStyles<typeof styles> {
    clientAppConfig: ClientAppConfig;
}

class Header extends React.Component<HeaderProps> {
    state = {
        companyLogo: null as string | null
    };


    render() {
        
        const { clientAppConfig, classes } = this.props;
        const { companyLogo } = this.state;

        return (
            <React.Fragment>
                {clientAppConfig.formType === 'ppp' ? (
                    <React.Fragment>
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <Typography variant="h4" color="inherit">
                                    CARES Act Paycheck Protection Program
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <AppBar color="default" className={classes.subBar} elevation={1}>
                            <Toolbar className={classes.subToolbar}>
                                <Typography color="inherit" variant="subtitle1">
                                    {clientAppConfig.companyName}
                                </Typography>
                            </Toolbar>
                            <Toolbar className={classes.subToolbar}>
                                <Person fontSize='medium' />&nbsp;
                                <Typography>{clientAppConfig.repName}</Typography>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <Phone fontSize='medium' />&nbsp;
                                <Typography>
                                    <Link href={"tel:" + clientAppConfig.repPhone}>
                                        {clientAppConfig.repPhone}
                                    </Link>
                                </Typography>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <Email fontSize='medium' />&nbsp;
                                <Typography>{clientAppConfig.repEmail}</Typography>
                            </Toolbar>
                        </AppBar>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                            { this.props.clientAppConfig.companyLogo !== undefined && this.props.clientAppConfig.companyLogo !== null && this.props.clientAppConfig.companyLogo.length > 0 ?
                                        <img src={this.props.clientAppConfig.companyLogo} alt="Company Logo" style={{ height: '50px' }} />
                                        :
                                    <Typography variant="h4" color="inherit" style={{ textAlign: 'center' }}>
                                        {this.props.clientAppConfig.companyName}
                                    </Typography>
                                }
                            </Toolbar>
                        </AppBar>
                        <AppBar color="default" className={classes.subBar} elevation={1}>
                            <Toolbar className={classes.subToolbar}>
                                <Person fontSize='medium' />&nbsp;
                                <Typography>{clientAppConfig.repName}</Typography>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <Phone fontSize='medium' />&nbsp;
                                <Typography>
                                    <Link href={"tel:" + clientAppConfig.repPhone} color="inherit">
                                        {clientAppConfig.repPhone}
                                    </Link>
                                </Typography>
                                <Hidden xsDown>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <Email fontSize='medium' />&nbsp;
                                    <Typography>
                                        <Link href={"mailto:" + clientAppConfig.repEmail} color="inherit">
                                            {clientAppConfig.repEmail}
                                        </Link>
                                    </Typography>
                                </Hidden>
                            </Toolbar>
                        </AppBar>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Header);